const getRoot = state => state.servicesSante.mentionsLegales

export const getMentionsLegales = state => getRoot(state).data
export const isLoading = state => getRoot(state).loading
export const getExpirationDate = state => getRoot(state).expirationDate
